import { Stack } from "@mui/material";
import { FormCategory } from "@simplyk/common";

import { FormChip } from "@/forms-design-system/FormChip";
import { useTranslate } from "@/hooks/useTranslate";

type ThemedPeerCredibilityChipGuestsCountProps = {
  totalCount?: number;
  weeklyCount?: number;
  formCategory: FormCategory;
};

export const ThemedPeerCredibilityChipGuestsCount = ({
  totalCount,
  weeklyCount,
  formCategory,
  ...rest
}: ThemedPeerCredibilityChipGuestsCountProps) => {
  const { t } = useTranslate();

  const getChipLabel = () => {
    if (formCategory === FormCategory.Event) {
      if (totalCount && totalCount >= 50) {
        return t("ticketing", "peerCredibilityChip.event.globalAttendance", { guestCount: totalCount });
      }
      if (weeklyCount && weeklyCount >= 25) {
        return t("ticketing", "peerCredibilityChip.event.weeklyAttendance", { guestCount: weeklyCount });
      }
    }

    if (formCategory === FormCategory.DonationForm || formCategory === FormCategory.PeerToPeerCampaign) {
      if (totalCount && totalCount >= 50) {
        return t("donationForm", "peerCredibilityChip.donation.globalAttendance", { paymentCount: totalCount });
      }
      if (weeklyCount && weeklyCount >= 25) {
        return t("donationForm", "peerCredibilityChip.donation.weeklyAttendance", { paymentCount: weeklyCount });
      }
    }

    if (totalCount && totalCount >= 50) {
      return t("ticketing", "peerCredibilityChip.otherTicketing.globalAttendance", { paymentCount: totalCount });
    }
    if (weeklyCount && weeklyCount >= 25) {
      return t("ticketing", "peerCredibilityChip.otherTicketing.weeklyAttendance", {
        paymentCount: weeklyCount,
      });
    }

    return null;
  };

  const chipLabel = getChipLabel();

  if (!chipLabel) {
    return null;
  }

  return (
    <Stack direction="row" spacing={1}>
      <FormChip vibe="neutral" variant="outlined" label={chipLabel} {...rest} />
    </Stack>
  );
};
